export default __webpack_public_path__ + "static/media/close.2205a383.svg";